import { render, staticRenderFns } from "./LinkedRemitterPage.vue?vue&type=template&id=38f6ba5e&scoped=true"
import script from "./LinkedRemitterPage.vue?vue&type=script&lang=js"
export * from "./LinkedRemitterPage.vue?vue&type=script&lang=js"
import style0 from "./LinkedRemitterPage.vue?vue&type=style&index=0&id=38f6ba5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f6ba5e",
  null
  
)

export default component.exports